<template>
  <div
    id="thank-you-page"
    v-if="surveyDetails && surveyDesign"
    :style="`background-color : ${surveyDesign.backgroundColor}`"
  >
    <b-container>
      <b-row>
        <b-col lg="10" class="mx-auto text-center">
          <b-img
            :src="
              surveyDesign.logo
                ? surveyDesign.logo
                : require('@/assets/images/rush-logo.png')
            "
            fluid
            alt="Survey Logo"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col
          lg="10"
          id="survey-title"
          :style="`color: ${surveyDesign.titleColor}; font-size: ${
            surveyDesign.titleFontSize
          }; text-align: ${surveyDesign.titleTextAlign}; font-weight: ${
            surveyDesign.isTitleBold ? 'bold' : 'normal'
          }; text-decoration: ${
            surveyDesign.isTitleUnderline ? 'underline' : 'none'
          }; font-style: ${surveyDesign.isTitleItalic ? 'italic' : 'normal'};`"
        >
          {{ surveyDetails.title }}
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="10" class="mx-auto text-center">
          <b-img
            :src="
              surveyDesign.imageThankYou
                ? surveyDesign.imageThankYou
                : require('@/assets/images/rush-banner.png')
            "
            fluid
            alt="Survey Thank You Image"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col
          lg="10"
          id="message"
          :style="`color: ${surveyDesign.thankYouMessageColor}; font-size: ${
            surveyDesign.thankYouMessageFontSize
          }; text-align: ${
            surveyDesign.thankYouMessageTextAlign
          }; font-weight: ${
            surveyDesign.isThankYouMessageBold ? 'bold' : 'normal'
          }; text-decoration: ${
            surveyDesign.isThankYouMessageUnderline ? 'underline' : 'none'
          }; font-style: ${
            surveyDesign.isThankYouMessageItalic ? 'italic' : 'normal'
          };`"
        >
          {{ surveyDetails.success_text }}
        </b-col>
      </b-row>
      <b-row v-if="surveyDetails.button_link">
        <b-col lg="4" class="mx-auto text-center">
          <b-button
            pill
            class="form-control pb-3"
            :style="`
              background-color: ${surveyDesign.themeColor};
              border-color: ${surveyDesign.themeColor};
              color: ${surveyDesign.buttonTextColor};
            `"
            :href="surveyDetails.button_link"
          >
            {{ surveyDetails.button_name }}
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ThankYou",
  props: ["uuid"],
  computed: {
    ...mapGetters("survey", ["surveyDetails", "surveyDesign"]),
  },
};
</script>

<style>
</style>